<template>
    <div>
        <message-list-skeleton v-show="showSkeleton"/>

        <ion-list v-show="!showSkeleton" class="ion-no-padding">
            <ion-list-header v-show="messages.length">
                <ion-label>{{ listTitle }}</ion-label>

                <ion-item lines="none" v-show="!$root.isMobileOrSmall">
                    <ion-button @click="$emit('refresh', $event)" button fill="outline" size="small">
                        <ion-icon ios='refresh-circle' md="refresh-circle" slot="icon-only"/>
                    </ion-button>
                </ion-item>
            </ion-list-header>

            <list-incoming-mail-message v-for="(message, i) in messages" :key="`${i}-${message.id}`" :message="message"/>

            <ion-infinite-scroll @ionInfinite="$emit('load-data', $event)" position="bottom" v-bind:class="{ 'infinite-scroll-enabled': !scrollEndReached }">
                <ion-infinite-scroll-content loadingSpinner="bubbles" loadingText="Loading more data…"/>
            </ion-infinite-scroll>
        </ion-list>
    </div>
</template>

<script>
    import MessageListSkeleton from "./MessageListSkeleton";
    import {MenuHandler} from "@/services/MenuHandler";
    import ListIncomingMailMessage from "@/components/messages/list/ListIncomingMailMessage";

    export default {
        components: {ListIncomingMailMessage, MessageListSkeleton},
        props: {
            messages: {
                type: Array,
                default: () => [],
            },
            pagination: {type: Object},
            listTitle: {type: String},
            showSkeleton: {
                type: Boolean,
                default: true,
            },
        },
        data() {
            return {
                infiniteScroll: {},
            }
        },
        computed: {
            scrollEndReached() {
                const lastPage = this.pagination.last_page;
                return lastPage && this.getCurrentPage() >= lastPage;
            },
        },
        methods: {
            getCurrentPage() {
                if (this.pagination && this.pagination.meta && this.pagination.meta.current_page) {
                    return this.pagination.meta.current_page;
                }
                return 1;
            },
            async goToPro() {
                await MenuHandler.open('pro')
            }
        },
        mounted() {
            this.infiniteScroll = document.getElementById('infinite-scroll');
        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
    .message {
        padding: 8px 0;
    }

    .upgrade-for-more {
        --ion-background-color: #eee;
        > ion-item {
            display: flex;
            > * {
                margin: 0 auto;
            }
        }
    }
</style>
